import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 48px;
  background-color: ${colors.Grey030};
  padding: 68px 42px;
  margin: 0px 48px;
  border-radius: 8px;
  border: 2px solid ${colors.GreyDefaultCardBorder};
  flex-wrap: wrap; /* permite quebrar linha em telas menores */

  /* Responsividade */
  @media (max-width: 1200px) {
    gap: 32px;
    padding: 56px 32px;
    margin: 0px 32px;
  }

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 24px;
    padding: 48px 24px;
    margin: 0px 24px;
  }

  @media (max-width: 768px) {
    gap: 16px;
    padding: 32px 16px;
    margin: 0px 16px;
  }

  @media (max-width: 480px) {
    gap: 12px;
    padding: 24px 12px;
    margin: 0px 8px;
  }
`;

export const Scroll = styled.div`
  overflow-x: auto;
`;

export const TextItalic = styled.i`
  color: ${colors.Grey400};
`;

export const ButtonExport = styled.button`
  color: ${colors.BlueSecondary};
  border: 1px solid ${colors.BlueSecondary};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;

export const BigNumberTitle = styled.strong`
  font-size: 18px;
`;

export const BigNumberSub = styled.p`
  font-size: 16px;
  color: ${colors.Grey400}
`;

export const ContainerTooltip = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-width: 250px;
  white-space: normal; /* <-- permite o texto quebrar */
  word-wrap: break-word; /* <-- evita overflow */
  line-height: 1.4; /* melhora a legibilidade */
  padding: 6px 0px; /* dá mais “respiro” */
`;

export const TooltipHeader = styled.strong`
font-size: 12px;
`;

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 10px;
    color: ${colors.White};
    font-weight: 700;
  }

  strong {
    font-size: 12px;
  }
`;

export const BoxHover = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12.6px;
`;

export const ContainerDate = styled.div`
  font-style: italic;
  text-align: right;
  width: 100%;
  color: ${colors.Grey400};
  font-size: 12px;
  margin-top: 10px;
`;

export const ContainerLoader = styled.div`
  width: 100%;
  height: 700px;
  background-color: ${colors.bg['soft-200']};
  opacity: 0.4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  p {
    opacity: 1;
  }
`;

export const ContainerBI = styled.div<{ height?: number; width?: number }>`
  position: relative;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  background-color: white;
  margin-top: 16px;
  padding: 0px 20px;
`;

export const BottomLayer = styled.div`
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  pointer-events: auto;
`;

export const ButtonExportBI = styled.button`
  color: ${colors.BlueSecondary};
  border: 1px solid ${colors.BlueSecondary};
  border-radius: 4px;
  background-color: ${colors.White};
  padding: 0px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 33px;
  font-weight: 600;
  gap: 6px;
  &:hover {
    cursor: pointer;
    background-color: ${colors.Blue050};
    border: 1px solid transparent;
  }
`;
